import {
    Grid,
    Typography,
    Card,
    CardMedia,
    CardContent,
    Button,
    Divider,
} from "@mui/material";
import { Container } from "@mui/system";
import globals from "../globals";
import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";
import LoadingPage from "../error_page/loadingPage";

const InstructorsPage = () => {
    const [instructors, setInstructors] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        fetch(globals.apiUrl + '/auth/instructor/')
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setInstructors(data);
                setLoading(false);
            })
            .catch(error => console.error('Error fetching instructors:', error));

    }, []);

    return (
        loading ? (
            <LoadingPage />
        ) : (
            <Container>
                <Helmet>
                    <title>Учители</title>
                    <meta name="description" content="Запознай се с учителите на eAcademiaBg – опитни и вдъхновяващи преподаватели, готови да помогнат на учениците да постигнат успех.
"/>
                </Helmet>
                <Grid container justifyContent={'center'} textAlign={'center'}>
                    <Grid item>
                        <Typography variant="h1" sx={{ color: globals.colors.lightRed, fontSize: 40, fontWeight: 'bold' }}>
                            Учители
                        </Typography>
                        <Typography variant="h2" sx={{ color: globals.colors.darkBlue, fontSize: 17, fontWeight: 'bold', mt: 3 }}>
                            Тук ще откриеш нашите опитни и ангажирани преподаватели, които предлагат индивидуални и групови онлайн курсове в различни области. Всеки от тях носи специализирани знания и индивидуален подход към ученика, с цел да изгради увереност и да постигне отлични резултати.
                        </Typography>
                    </Grid>

                    <Grid container spacing={3} sx={{ m: 0 }} justifyContent={'center'} textAlign={'center'} alignItems={'center'} alignContent={'center'}>
                        {instructors.map((i) => (
                            <Grid item xs={12} sm={4} sx={{ mt: 3 }}>
                                <Card sx={{ maxWidth: 300 }}>
                                    <CardMedia
                                        sx={{ height: 200 }}
                                        image={(i.image_url) ? i.image_url : '/noone.webp'} height={250} width={250} style={{ borderRadius: 10 }}
                                />
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div" sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 20 }}>
                                            {i.first_name} {i.last_name}
                                        </Typography>
                                        <Divider />
                                        <Typography sx={{ mt: 2, fontSize: 17, color: globals.colors.lightRed, fontWeight: 'bold' }}>
                                            {i.courses} {i.courses === 1 ? 'курс' : 'курса'}
                                        </Typography>
                                        <Button variant='contained' href={`/instructor/${i.id}`} type='submit' size='large' sx={{
                                            mt: 2, px: 5, backgroundColor: globals.colors.darkBlue, textTransform: 'none', '&:hover': {
                                                backgroundColor: globals.colors.lightBlue
                                            },
                                        }}>Към профил</Button>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Container>
        )
    );
}

export default InstructorsPage